import type { GithubInstallation } from "@auradata/contracts";

/** Where "Change which repositories the App can read" / "Manage repository access" goes. */
export function githubManageUrl(installation: GithubInstallation): string {
  return installation.accountType === "Organization"
    ? `https://github.com/organizations/${installation.account}/settings/installations/${installation.installationId}`
    : `https://github.com/settings/installations/${installation.installationId}`;
}

/** A tiny "pushed 3 days ago" relative-time label; null when GitHub didn't report a push. */
export function relativeTime(iso: string | null): string | null {
  if (!iso) return null;
  const minutes = Math.round((Date.now() - new Date(iso).getTime()) / 60_000);
  if (minutes < 1) return "just now";
  if (minutes < 60) return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"} ago`;
  const days = Math.round(hours / 24);
  if (days < 30) return `${days} day${days === 1 ? "" : "s"} ago`;
  const months = Math.round(days / 30);
  if (months < 12) return `${months} month${months === 1 ? "" : "s"} ago`;
  const years = Math.round(months / 12);
  return `${years} year${years === 1 ? "" : "s"} ago`;
}
